import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  author: string;
  rating: number;
  chapters: number;
  status: string;
  tags?: string[];
  variant?: 'default' | 'featured';
}

export default function ComicCard({
  id,
  title,
  cover,
  author,
  rating,
  chapters,
  status,
  tags = [],
  variant = 'default',
}: ComicCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${id}`}
        className="group block bg-foreground-900 rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
      >
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={cover}
            alt={title}
            title={`${title} - 韩国漫画在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-transparent to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <h3 className="text-lg font-bold text-background-50 whitespace-nowrap overflow-hidden text-ellipsis">
              {title}
            </h3>
            <p className="text-xs text-background-50/70 mt-1">{author}</p>
            <div className="flex items-center gap-3 mt-2">
              <span className="flex items-center gap-1 text-xs text-primary-300">
                <i className="ri-star-fill text-xs"></i>
                {rating}
              </span>
              <span className="text-xs text-background-50/50">
                共{chapters}话
              </span>
              <span className="px-2 py-0.5 bg-accent-500/80 text-background-50 text-xs rounded-full whitespace-nowrap">
                {status}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02]"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩国漫画在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {tags.length > 0 && (
          <div className="absolute top-3 left-3">
            <span className="px-2 py-0.5 bg-primary-500/90 text-background-50 text-xs rounded-full whitespace-nowrap">
              {tags[0]}
            </span>
          </div>
        )}
        <div className="absolute top-3 right-3">
          <span className="px-2 py-0.5 bg-foreground-950/60 text-background-50 text-xs rounded-full whitespace-nowrap">
            {status}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{author}</p>
        <div className="flex items-center justify-between mt-2.5">
          <span className="flex items-center gap-1 text-xs text-primary-500">
            <i className="ri-star-fill text-xs"></i>
            {rating}
          </span>
          <span className="text-xs text-foreground-400">
            共{chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}

export { type ComicCardProps };